import { render, staticRenderFns } from "./checkHistory.vue?vue&type=template&id=6d55094e&scoped=true&"
import script from "./checkHistory.vue?vue&type=script&lang=js&"
export * from "./checkHistory.vue?vue&type=script&lang=js&"
import style0 from "./checkHistory.vue?vue&type=style&index=0&id=6d55094e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55094e",
  null
  
)

export default component.exports